
import StorageService from '../../../services/api/Storage';
import CommonService from '../../../services/api/Common'
import axios from 'axios'
import FileJobsService from '../../../services/api/FileJobs';
import moment from 'moment';
import { toast } from 'react-toastify';
import { provisioners}  from '../../../settings/shared/constants'

/**
 * Save file content in the storage.
 * 
 * @param {String} filePath - Storage file path
 * @param {*} fileType - File Content-Type
 * @param {*} content - File content
 */
export const saveFile = (filePath, fileType, content, storageName, rootFolder, savecomments) => {
    let contentType = 'application/octet-stream'
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    if(fileType !== undefined) {
        if(fileType === 'ipynb') {
            contentType = 'application/vnd.decisionforce.notebook'
        }
    }
    StorageService.uploadObjectUrl(filePath, storageName, rootFolder)
    .then((response) => {
      let currentUser = JSON.parse(localStorage.getItem("UserProfile"))
      let apitoken = currentUser.apiToken;
      let createdBy = currentUser.firstName + currentUser.lastName;
      let savefiledata = {}
      if(fileType === 'ipynb') {
       savefiledata = {
        "filePath": filePath,
        "sourceStorage": {
          "apiKey": apitoken,
          "rootFolder": rootFolder,
          "storageId": storageName
        },
        "versionInfo": {
          "comment": savecomments,
          "createdAt": moment.utc(new Date()).local().format('MMM DD, YYYY HH:mm a'),
          "createdBy": createdBy
        }
      }
    }
      if (response.type === provisioners.google) {
        axios({
            url: response.upload_url,
            baseURL: '',
            data: {},
            headers: {
              'content-type': contentType,
              'x-goog-resumable': 'start'
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            const resumableLink = resp.headers.location
        CommonService({
          url: resumableLink,
          baseURL: '',
          data: JSON.stringify(content),
          headers: {
            'content-type': "multipart/form-data"
          },
          method: 'PUT',
          cancelToken: source.token,
        }).then((resp) => {
          if(savecomments !== undefined && savecomments !== null){
          if(fileType === 'ipynb') {
          FileJobsService.SaveVersion(savefiledata)
          .then((response) => {
            toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);
          });
        }
      }
        })
        
          }); 

        } else if (response.type === provisioners.aws) {
          var rest = response.fields;
          var formData = new FormData();
          for (const[key, value] of Object.entries(rest)) {
            formData.append(key, value)
          }
          formData.append("file", JSON.stringify(content))
          axios({
            url: response.upload_url,
            data: formData,
            headers: {
              'content-type': "multipart/form-data"
            },
            method: 'POST',
            cancelToken: source.token
          }).then((resp) => {
            if(savecomments !== undefined && savecomments !== null){
              if(fileType === 'ipynb') {
            FileJobsService.SaveVersion(savefiledata)
            .then((response) => {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);      
            });
          }
        }
          })
        } else if (response.type ===  provisioners.azure){
          axios({
            url: response.upload_url,
            data: JSON.stringify(content),
            headers: {
              'content-type': "multipart/form-data",
              'x-ms-blob-type' : 'BlockBlob'
            },
            method: 'PUT',
            cancelToken: source.token
          }).then((resp) => {
            if(savecomments !== undefined && savecomments !== null){
              if(fileType === 'ipynb') {
              FileJobsService.SaveVersion(savefiledata)
              .then((response) => {
                toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">File Updated Successfully!</b></i>);      
              });
            }
          }
          })
        }

    });


}